angular.module('shbdeployer.app').controller('CreateProjectController', [
  '$scope',
  '$state',
  'ProjectService',
  'EndpointService',
  'Notifications',
  function ($scope, $state, ProjectService, EndpointService, Notifications) {
    $scope.formValues = {
      Name: '',
      Description: '',
      EndpointId: null,
      ZipFile: null,
      SourceURL: '',
    };

    $scope.state = {
      actionInProgress: false,
      uploadValidationError: '',
      sourceMethod: 'upload',
    };

    $scope.uploadFile = function (file) {
      $scope.formValues.ZipFile = file;
      $scope.state.uploadValidationError = '';
      if (file && !/\.zip$/i.test(file.name)) {
        $scope.state.uploadValidationError = 'Выберите файл с расширением .zip';
        $scope.formValues.ZipFile = null;
      }
    };

    $scope.createProject = function () {
      var isUpload = $scope.state.sourceMethod === 'upload';

      if (isUpload && !$scope.formValues.ZipFile) {
        $scope.state.uploadValidationError = 'Загрузите ZIP-архив с кодом проекта';
        return;
      }
      if (!isUpload && !$scope.formValues.SourceURL) {
        $scope.state.uploadValidationError = 'Укажите ссылку на ZIP-архив с кодом проекта';
        return;
      }

      $scope.state.actionInProgress = true;
      var action = isUpload
        ? ProjectService.createProjectFromZipUpload($scope.formValues.Name, $scope.formValues.Description, $scope.formValues.ZipFile, $scope.formValues.EndpointId)
        : ProjectService.createProjectFromUrl($scope.formValues.Name, $scope.formValues.Description, $scope.formValues.SourceURL, $scope.formValues.EndpointId);

      action
        .then(function success() {
          Notifications.success('Проект создан и развернут', $scope.formValues.Name);
          $state.go('shbdeployer.projects');
        })
        .catch(function error(err) {
          Notifications.error('Ошибка', err, 'Не удалось создать проект');
        })
        .finally(function final() {
          $scope.state.actionInProgress = false;
        });
    };

    function initView() {
      EndpointService.endpoints(undefined, undefined, { types: [1, 2] })
        .then(function success(data) {
          $scope.endpoints = data.value;
          if (data.value.length > 0) {
            $scope.formValues.EndpointId = data.value[0].Id;
          }
        })
        .catch(function error(err) {
          $scope.endpoints = [];
          Notifications.error('Ошибка', err, 'Не удалось получить список окружений Docker');
        });
    }

    initView();
  },
]);
